import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { differentRows } from "@/mocks/ppcare";

export default function DifferentSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Telemedicine Visits with Personal Physician Care"
            title={
              <>
                What Makes Us <span className="text-accent-500">Different</span>
              </>
            }
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mx-auto mt-14 max-w-4xl overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="grid grid-cols-[1.6fr_1fr_1fr] items-stretch">
              <div className="flex items-center p-4 md:p-5">
                <span className="text-2xl font-bold text-foreground-300 md:text-3xl">#</span>
              </div>
              <div className="flex items-center justify-center bg-primary-500 p-4 text-center md:p-5">
                <h3 className="text-sm font-bold text-background-50 md:text-base">
                  Personal Physician Care
                </h3>
              </div>
              <div className="flex items-center justify-center bg-background-200 p-4 text-center md:p-5">
                <h3 className="text-sm font-bold text-foreground-700 md:text-base">
                  Typical Doctor&apos;s Office
                </h3>
              </div>

              {differentRows.map((row, index) => (
                <div key={row.label} className="contents">
                  <div
                    className={`flex items-center p-4 text-sm text-foreground-800 md:p-5 md:text-base ${
                      index % 2 === 1 ? "bg-background-100/60" : ""
                    }`}
                  >
                    <span className="mr-3 font-semibold text-accent-600">{index + 1}*</span>
                    {row.label}
                  </div>
                  <div
                    className={`flex items-center justify-center p-4 md:p-5 ${
                      index % 2 === 1 ? "bg-background-100/60" : ""
                    }`}
                  >
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-check-line text-lg" />
                    </span>
                  </div>
                  <div
                    className={`flex items-center justify-center p-4 md:p-5 ${
                      index % 2 === 1 ? "bg-background-100/60" : ""
                    }`}
                  >
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-close-line text-lg" />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}